import React, {FC} from 'react';

import {
    IconButton as MuiIconButton,
    IconButtonProps as MuiIconButtonProps
} from '@material-ui/core';
import {withStyles} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Theme} from '@material-ui/core';

import Paper from '@material-ui/core/Paper';

const StyledIconButton = withStyles({
    root: {
        borderRadius: 4
    }
})(MuiIconButton);

export interface IconButtonProps extends MuiIconButtonProps {
    isOpen?: boolean;
}

const useStyles = makeStyles<Theme, IconButtonProps>(theme => ({
    root: {
        margin: 0,
        borderRadius: 4,
        backgroundColor: props => (props.isOpen ? theme.palette.action.hover : 'inherit')
    }
}));

const IconButton: FC<IconButtonProps> = (props: IconButtonProps) => {
    const {children, onClick} = props;

    const classes = useStyles(props);

    return (
        <Paper classes={classes}>
            <StyledIconButton onClick={onClick}>{children}</StyledIconButton>
        </Paper>
    );
};

export default IconButton;
